import { CUSTOMER_EVENTS } from 'src/boot/tracking/events'

/**
 * Documentation: https://developers.facebook.com/docs/meta-pixel/guides/track-multiple-events
 */
export function trackEventViaMeta (name, data, skipExtraEvents = false) {
  if (typeof window.fbq === 'function') {
    try {
      window.fbq('track', name, data)
    } catch (e) {
      // eslint-disable-next-line no-undef
      Rollbar.error('Failed to track event via Meta', e)
    }
  }

  if (!skipExtraEvents) {
    // Prefer to send Meta's "standard events" when possible. See below.
    const payload = getStandardEventFromIndyEvent(name, data)
    if (payload) {
      trackEventViaMeta(payload.name, payload.data, true)
    }
  }
}

export function trackPageViaMeta (data) {
  if (typeof window.fbq === 'function') {
    try {
      window.fbq('track', 'PageView', data)
    } catch (e) {
      // eslint-disable-next-line no-undef
      Rollbar.error('Failed to track page view via Meta', e)
    }
  }
}

/**
 * Get an event payload object containing the `name` and `data` for a
 * Meta "standard event" that resembles one of our own internal events.
 * Returns `null` if no such event exists. We want to send Meta's predefined
 * standard events whenever possible to enable additional analytics features.
 *
 * Documentation: https://developers.facebook.com/docs/meta-pixel/reference
 */
export function getStandardEventFromIndyEvent (indyEventName, indyEventData = {}) {
  // At least `name` must be set to trigger a standard event.
  const standardEvent = { name: null, data: null }

  switch (indyEventName) {
    case CUSTOMER_EVENTS.ADDED_FAVORITE:
      standardEvent.name = 'AddToWishlist'
      break
    case CUSTOMER_EVENTS.ADDED_USUAL_ORDER:
      standardEvent.name = 'AddToCart'
      break
    case CUSTOMER_EVENTS.REMOTE_ORDER_PLACED:
      standardEvent.name = 'Purchase'
      standardEvent.data = {
        content_name: indyEventData.movieName,
        num_items: indyEventData.itemCount,
        currency: indyEventData.currency ? indyEventData.currency.toUpperCase() : undefined,
        value: indyEventData.total
      }
      break
    case CUSTOMER_EVENTS.SUBSCRIBED_TO_MARKETING_LISTS:
      standardEvent.name = 'Lead'
      break
    case 'Viewed Showing Checkout':
      standardEvent.name = 'InitiateCheckout'
      break
  }

  return standardEvent.name ? standardEvent : null
}
